import type { QuickSuggestion, ContactCTA } from '@/types/chatbot'

/**
 * Quick suggestion buttons shown when the chat is empty.
 * Each entry uses i18n translation keys for label and message.
 *
 * Example:
 * ```ts
 * export const quickSuggestions: QuickSuggestion[] = [
 *   {
 *     id: '1',
 *     labelKey: 'chatbot.suggestions.services',
 *     messageKey: 'chatbot.suggestions.servicesMessage',
 *   },
 * ]
 * ```
 */
export const quickSuggestions: QuickSuggestion[] = [
  {
    id: '1',
    labelKey: 'chatbot.suggestions.products',
    messageKey: 'chatbot.suggestions.productsMessage',
  },
  {
    id: '2',
    labelKey: 'chatbot.suggestions.history',
    messageKey: 'chatbot.suggestions.historyMessage',
  },
  {
    id: '3',
    labelKey: 'chatbot.suggestions.recipes',
    messageKey: 'chatbot.suggestions.recipesMessage',
  },
  {
    id: '4',
    labelKey: 'chatbot.suggestions.buy',
    messageKey: 'chatbot.suggestions.buyMessage',
  },
  {
    id: '5',
    labelKey: 'chatbot.suggestions.certifications',
    messageKey: 'chatbot.suggestions.certificationsMessage',
  },
]

export const contactCTAs: ContactCTA[] = [
  {
    id: 'phone',
    labelKey: 'chatbot.cta.phone',
    value: '+39 019 510 600',
  },
  {
    id: 'email',
    labelKey: 'chatbot.cta.email',
    value: 'info@noberasco.it',
  },
]
